export const ACCOUNT = 'ACCOUNT';

export const UPDATE_ACCOUNT = `${ACCOUNT}/UPDATE_ACCOUNT`;